import { render, staticRenderFns } from "./PlansAddNew.vue?vue&type=template&id=37097320&"
import script from "./PlansAddNew.vue?vue&type=script&lang=js&"
export * from "./PlansAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PlansAddNew.vue?vue&type=style&index=0&id=37097320&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports